import classNames from "classnames/bind";
import styles from "./Sidebar.module.scss";
import MenuItem from "./Menu/MenuItem";
const cx = classNames.bind(styles);

function Sidebar({ dataMenu }: any) {
  return (
    <div className={cx("wrapper")}>
      <nav className={cx("navWrapper")}>
        <div className={cx("title")}>
          <h3>DEV BETTER</h3>
        </div>
        {/* <br /> */}

        {dataMenu.map((item: any, index: number) => {
          return (
            <div key={index}>
              <MenuItem title={item.title} to={item.to} icon={item.icon} />
            </div>
          );
        })}
      </nav>
    </div>
  );
}

export default Sidebar;
